@if (isAdvancedSearchApplied()) {
  <app-context-menu-item
    [withCheckOption]="true"
    [close]="true"
    title="All results"
  icon="sapphire-search"
    [active]="filterKey === 'search_results'"
    (execute)="selectFilter('search_results')"
  />
}
<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Events"
  icon="sapphire-events"
  [active]="filterKey === 'all_events'"
  (execute)="selectFilter('all_events')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Flagged"
  icon="sapphire-flagged"
  [active]="filterKey === 'flagged'"
  (execute)="selectFilter('flagged')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Follow Up"
  icon="sapphire-follow-up"
  [active]="filterKey === 'followed'"
  (execute)="selectFilter('followed')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Snoozed"
  icon="sapphire-snooze"
  [active]="filterKey === 'snoozed'"
  (execute)="selectFilter('snoozed')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Archive"
  icon="sapphire-archive"
  [active]="filterKey === 'archived'"
  (execute)="selectFilter('archived')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Trash"
  icon="sapphire-trash"
  [active]="filterKey === 'deleted'"
  (execute)="selectFilter('deleted')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Calendars"
  icon="sapphire-calendars"
  [active]="filterKey === 'all_calendars'"
  (execute)="selectFilter('all_calendars')"
/>
